import React from "react";
import {Typography} from "@material-ui/core";
import {classes} from "../api/constants";

const TMSearchResultItem = ({trademark, openDetail}) => {
    return (
        <div className="p-4 flex flex-col sm:flex-row">
            <div className='flex-1'>
                <h3 className="text-lg font-medium">{trademark.wordmark}</h3>
                <p><span className="font-medium">Class :</span> {trademark.class}</p>
                <p><span className="font-medium">Status : </span>{trademark.status}</p>
                <p><span className="font-medium">Application Number : </span>{trademark.application_number}</p>
                <p><span className="font-medium">Application Date : </span>{trademark.application_date}</p>
                <p><span className="font-medium">Used Since : </span>{trademark.used_since}</p>
                <p><span className="font-medium">Valid Upto : </span>{trademark.valid_upto}</p>
                <p><span className="font-medium">Appplicant Name : </span>{trademark.proprietor}</p>
                <p><span className="font-medium">Goods & Services : </span>{trademark.goods_and_services}</p>
                <p><span className="font-medium"> Journal no. : </span>{trademark.journal_number}</p>
                <p><span className="font-medium"> Journal Date : </span>{trademark.journal_date}</p>

            </div>
            <div className='sm:ml-8'>
                {trademark.image ?
                    <img src={trademark.image} className='h-32 w-32'/>
                    :
                    <p className='h-32 w-32 text-gray-400 text-center justify-center'>No Image</p>
                }
            </div>
        </div>

    )
}

export default TMSearchResultItem;